<template lang="pug">
.k-item.k-admin-release.body.denied( 
  v-if='object.error_data'
  :key ='object.error_data.ach_access_denied && object.error_data.ach_access_denied.redirect'
)
  i-lock.icon( title='Denied' )
  span.text Permission denied
.k-item.k-admin-release.body( v-else :key='object.id' )
  .title
    w-btn-icon.drag-handle( no-hover size='lg2' )
      //- TODO: startdrag
      i-drag.icon( title='Drag to reorder')
    .label
      .label(
        v-html='`${releasePrefix}${object.title && object.title.rendered}`'
        @click.prevent='setCurrentObject'
      )
      transition( name='fade' mode='out-in' )
        i-plus.icon( v-if='active' title='Collapse' )
        i-minus.icon( v-else title='Collapse' )
  transition( name='height' appear )
    .info
      template( v-for='( value, key ) in object.restrictions' )
        template( v-if=`key === 'preview'` )
          .tag( v-if='value' )
            i-video.icon( decorative )
            span
              | preview: {{ `#${value.ID}` }}
        template( v-else-if=`key === 'show'` )
          .tag( v-if='value' )
            i-eye.icon( title='Visible to unpermitted' )
            span
              | visible
        template( v-else-if=`key === 'product'` )
          .tag( v-if=`value && value.ID` )
            i-cart.icon( title='Associted product' )
            span product: {{ `#${value.ID}` }}
        template( v-else-if=`key === 'users'` )
          .tag( v-for=`user in value` )
            i-lock-open.icon( title='Visible to' )
            span user: {{ user.display_name }}
        template( v-else-if=`key === 'show'` )
          span
        .tag( v-else-if=`key !== 'plus' && value` )
          i-lock-open.icon( title='Visible to' )
          span {{ key }}
  transition( name='height' appear )
    .more( v-if='active')
      k-video-player( :content='object' )
      .content
        template( v-for='( item, label) in object' )
          .key {{ label }}
          json-tree.value( :data='item' )

</template>

<script lang="js">
import JsonTree from 'vue-json-tree'
import KVideoPlayer from '@/blocks/k-video-player'
import WBtnIcon from '@/widgets/w-btn-icon'
import ILock from 'icons/Lock'
import ILockOpen from 'icons/LockOpenVariant'
import IVideo from 'icons/Video'
import ICart from 'icons/Cart'
import IChevronUp from 'icons/ChevronUp'
import IChevronDown from 'icons/ChevronDown'
import IDrag from 'icons/Drag'
import IEye from 'icons/Eye'
import IMinus from 'icons/Minus'
import IPlus from 'icons/Plus'

export default {
  name: 'AdminReleaseBlock',
  mixins: [],
  components: {
    JsonTree,
    KVideoPlayer,
    WBtnIcon,
    ILock,
    ILockOpen,
    IVideo,
    ICart,
    IChevronUp,
    IChevronDown,
    IDrag,
    IEye,
    IMinus,
    IPlus,
  },
  props: {
    object: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {
    setCurrentObject() {
      this.$emit( 'focus', this.active ? null : this.object )
    }
  },
  computed: {
    releasePrefix() {
      return this.object.release_number ? `${this.object.release_number}: ` : ''
    }
  }
}
</script>

<style lang="scss">
.k-admin-release {
  .label {
    display: flex;
    align-items: center;
    font-size: var(--s-base);
    .label {
      flex: 1;
      font-size: var(--s-base);
    }
  }
  .k-video-player {
    --c-fg: white;
    position: relative;
    .video-js {
      position: relative;
    }
  }
  .content > .key {
    text-align: right;
  }
}
</style>
